import { pages } from "../common/pages";

const defaultHiddenColumns = {
  // Type curve metrics and the as-struck stage start hidden — toggle on via
  // "Change Columns".
  [pages.UnitEvaluationWells]: [
    "stage",
    "peak_3m_avg_oil",
    "peak_3m_avg_gas",
    "first_12m_oil",
    "first_12m_gas",
  ],
  [pages.OwnerUnits]: [
    "name",
    "owner_zip_code",
    "acres",
    "landtrac_unit_acres",
    "landtrac_unit_api_uwi_10",
    "legal_description",
    "last_unit_evaluation.created_at",
    "owner_address",
    "wells_last_production_date",
  ],
  [pages.UnitOwners]: [
    "address",
    "address_unit_count",
    "nraEstimate",
    "owner_name",
    "owner_address",
    "owner_zip_code",
    "legal_description",
  ],
  [pages.EvaluationInterests]: [
    "unit_evaluation_id",
    "tract_description",
    // lease columns (enverus_lease / enverus_landtrac_lease) — toggle on via
    // "Change Columns".
    "lease_id",
    "enverus_lease_id",
    "enverus_landtrac_lease_id",
    "lease_grantor",
    "lease_grantee",
    "lease_county",
    "lease_acres",
    "lease_record_date",
    // owner_unit_interest
    "owner_unit_interest.owner_name",
    "owner_unit_interest.owner_address",
    "owner_unit_interest.owner_city",
    "owner_unit_interest.owner_state",
    "owner_unit_interest.owner_zip_code",
    "owner_unit_interest.tax_year",
    "owner_unit_interest.decimal_interest",
    // unit_evaluation
    // "unit_evaluation.id",
    "unit_evaluation.created_at",
    "unit_evaluation.production_oil_last_3m_avg",
    "unit_evaluation.production_gas_last_3m_avg",
    "unit_evaluation.value_per_nra_total_v1",
    // unit
    "unit.name_formatted",
    "unit.operator",
    "unit.acres",
    "unit.landtrac_unit_acres",
    "unit.landtrac_unit_api_uwi_10",
    "unit.wells_last_production_date",
  ],
  [pages.OwnerIDIPersons]: [
    "idi_search_id",
    "pid",
    "first_name",
    "last_name",
    "created_at",
    "updated_at",
  ],
  [pages.OwnerNameAddressValidationCluster]: [
    "street",
    "is_shared_address",
    "geocoded_address.source",
    "gfr_count",
    "oui_count",
  ],
  [pages.OwnerOwnerNameAddresses]: [
    // "name_formatted",
    "validation_cluster_id",
    "cluster_id_new",
    "name_parsed",
    "street",
    "geocoded_address.source",
    "gfr_count",
    "oui_count",
    "generational_suffix",
  ],
  [pages.TaxRollLeads]: [
    "created_at",
    "decimal_interest",
    "interest_type",
    "tax_year",
    // user
    "user.alias",
    // owner
    "owner.last_offer_date",
    "owner.last_idi_person_id",
    "owner.last_usps_address_id",
    // "owner.bad",
    "owner.nra_estimate",
    "owner.highest_offer_amount",
    "owner.cashflow_estimate",
    "owner.value_estimate",
    "owner.unit_count",
    "owner.address_unit_count",
    "owner.unique_unit_count",
  ],
  [pages.LeaseLeads]: [
    "created_at",
    // Raw lease ids hidden by default — togglable via Change Columns. The
    // Source column already shows which side ("lease" vs "landtrac_lease").
    "enverus_lease_id",
    "enverus_landtrac_lease_id",
    // user
    "user.alias",
    // owner
    "owner.last_offer_date",
    "owner.last_idi_person_id",
    "owner.last_usps_address_id",
    // enverus_lease
    "enverus_lease.grantee_name",
    "enverus_lease.section",
    "enverus_lease.township",
    "enverus_lease.range",
    "enverus_lease.block",
    "enverus_lease.abstract_no",
    "enverus_lease.survey_name",
  ],
  // The new informational/calculated columns start hidden — toggle on via
  // "Change Columns". Keep both tables' lists in sync.
  [pages.ManagementWellAssets]: [
    "last_production_date",
    "last_royalty_date",
    "total_royalties",
    "asset_allocation_calculated",
    "asset_allocation_from_decimal_interest",
    "decimal_interest_calculated",
    "revenue_allocation_calculated",
    "previous_decimal_interest",
    "division_order_decimal_interest",
  ],
  [pages.AssetManagementWells]: [
    "last_production_date",
    "last_royalty_date",
    "total_royalties",
    "asset_allocation_calculated",
    "asset_allocation_from_decimal_interest",
    "decimal_interest_calculated",
    "revenue_allocation_calculated",
    "previous_decimal_interest",
    "division_order_decimal_interest",
  ],
};

export { defaultHiddenColumns };
